<template>
  <div>
    <div class="from">
      <LyTableFilter :queryData.sync="queryData" ref="tableFilterMain" />
      <div class="buttoncontent">
        <el-button size="mini" type="primary" @click="addInfo">新增</el-button>
        <el-button size="mini" type="primary" @click="addexecl">导入</el-button>
        <el-button size="mini" type="primary" @click="exportExecl">导出</el-button>
        <el-button size="mini" type="primary" @click="opationCard"
          >批量操作手机卡状态</el-button
        >
      </div>
    </div>
    <div class="table">
      <div
      :class="['Table__TopPage--middle', 'CustomerManageTable__allPage']"
    >
      共{{ pagerData.total }}条 | 每页{{ pagerData.pageSize }}条 | 共{{ pagerData.totalPage }}页
    </div>
    <LyTable
      ref="tableMain"
      :list="list"
      v-loading="loading"
      @pagination="getList"
      :pagerData.sync="pagerData"
      :selectedList.sync="multipleSelection"
      @selected="handleSelecte"
      :downLoading.sync="downLoading"
    />
    </div>
    
    <Dialog @uploaded="getList" ref="dialog" />
    <UploadDIalog :show.sync="show" @uploaded="getList"/>
  </div>
</template>

<script>
import { getListData , deteleInfo, cancleInfo } from "./api";
import Dialog from './Dialog.vue';
import departmentcomponent from "./department.vue";
import moment from "moment";
import UploadDIalog from './UploadDialog.vue'

export default {
  name: "StandingBook",
  components: { Dialog, UploadDIalog },
  inject: ["path"],
  data() {
    return {
      queryData: {},
      multipleSelection: [],
      list: [],
      loading: false,
      pagerData: {
        total: 0,
        pageIndex: 1,
        pageSize: 10,
        totalPage: 1
      },
      downLoading: true,
      show: false,
    };
  },
  computed: {
    filterConfig() {
      return {
        filterData: [
          {
            label: "部门",
            prop: "dep_id",
            type: "component",
            defaultVal: undefined,
            component: departmentcomponent,
          },
          {
            label: "使用人工号",
            prop: "use_username",
            defaultVal: undefined,
            placeholder: "请输入内容",
          },
          {
            label: "使用人姓名",
            prop: "use_realname",
            defaultVal: undefined,
            placeholder: "请输入内容",
          },
          {
            label: "实名办卡人姓名",
            prop: "card_realname",
            defaultVal: undefined,
            placeholder: "请输入内容",
          },
          {
            label: "手机号",
            prop: "phone",
            defaultVal: undefined,
            placeholder: "请输入内容",
          },
          {
            label: "微信用途",
            prop: "weixin_use",
            type: "select",
            defaultVal: undefined,
            options: {
              opts: [
                {
                  value: "企业关联",
                  key: 1,
                },
                {
                  value: "助理号",
                  key: 2,
                },
                {
                  value: "分享",
                  key: 3,
                },
                {
                  value: "老师专线",
                  key: 4,
                },
                {
                  value: "其他",
                  key: 5,
                }
              ],
            },
            placeholder: "请选择",
          },
          {
            label: "微信号",
            prop: "weixin",
            defaultVal: undefined,
            placeholder: "请输入内容",
          },
          {
            label: "微信状态",
            prop: "weixin_status",
            type: "select",
            defaultVal: undefined,
            options: {
              opts: [
                {
                  value: "正常",
                  key: 1,
                },
                {
                  value: "短期封号",
                  key: 2,
                },
                {
                  value: "长期封号",
                  key: 3,
                },
              ],
            },
            placeholder: "请选择",
          },
          {
            label: "手机卡状态",
            prop: "card_status",
            type: "select",
            defaultVal: undefined,
            options: {
              opts: [
                {
                  value: "正常",
                  key: 1,
                },
                {
                  value: "注销",
                  key: 2,
                },
              ],
            },
            placeholder: "请选择",
          },
          {
            label: "微信来源",
            prop: "weixin_from",
            type: "select",
            defaultVal: undefined,
            options: {
              opts: [
                {
                  value: "注册",
                  key: 1,
                },
                {
                  value: "购买",
                  key: 2,
                }
              ],
            },
            placeholder: "请选择",
          },
          {
            label: "封号日期",
            prop: "time",
            type: "date",
            defaultVal: undefined,
            options: {
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
            },
          },
          {
            label: "ICCID",
            prop: "phone_iccid",
            defaultVal: undefined,
            placeholder: "请输入内容",
          },
          {
            label: "发放时间",
            prop: "cardtime",
            type: "date",
            defaultVal: undefined,
            options: {
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
            },
          },
        ],
        buttonsData: {
          buttonsList: [
            {
              text: "查询",
              handle: this.getList,
              type: "",
              size: "mini",
            },
            {
              text: "清空",
              type: "",
              handle: this.clear,
              size: "mini",
            },
          ],
          config: {
            align: "center",
          },
        },
      };
    },
    tableConfig() {
      return {
        columns: [
          { label: "手机号", prop: "phone", minWidth: 120 },
          { label: "微信号", prop: "weixin_no", minWidth: 120 },
          { label: "微信用途", prop: "weixin_use_lable", minWidth: 120 },
          { label: "组别", prop: "use_dep", minWidth: 120 },
          {
            label: "使用人工号",
            prop: "use_user",
            minWidth: 120,
            format: (val) => {
              return val.username;
            },
          },
          {
            label: "使用人姓名",
            prop: "use_user",
            minWidth: 120,
            format: (val) => {
              return val.realname;
            },
          },
          { label: "在线状态", prop: "card_status_lable", minWidth: 120 },
          { label: "微信号状态", prop: "weixin_status_lable", minWidth: 120 },
          { label: "手机卡状态", prop: "card_status_lable", minWidth: 120 },
          { label: "封号日期", prop: "weixin_c_time", minWidth: 120 },
          { label: "ICCID", prop: "phone_iccid", minWidth: 120 },
          { label: "更新时间", prop: "updated_time", minWidth: 120 },
        ],
        operate: {
          operateColumnsLabel: "操作",
          operateColumnsFixed: "right",
          operateColumnsDirection: "row",
          operateColumnsWidth: "230",
          operateColumnsType: "button",
          operateColumns: [
            {
              text: "查看",
              method: ({ row }) => {
                this.getdetail(row.id);
              },
            },
            {
              text: "删除",
              method: ({ row }) => {
                this.delete(row.id)
              },
            },
            {
              text: "编辑",
              method: ({ row }) => {
                this.edit(row)
              },
            },
          ],
        },
        selection: true,
      };
    },
  },
  async mounted() {
    await this.getList();
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.$refs["tableFilterMain"].init(this.filterConfig);
      this.$refs["tableMain"].init(this.tableConfig);
    },
    async getList() {
      this.show = false
      let params = {
        pageSize: this.pagerData.pageSize,
        page: this.pagerData.pageIndex,
        ...this.queryData,
      }
      if (!!params.time) {
        params.start_update_at = moment(params.time[0])
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        params.end_update_at = moment(params.time[1])
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      delete params.time;
      if (!!params.cardtime) {
        params.start_card_send_time = moment(params.cardtime[0])
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        params.end_card_send_time = moment(params.cardtime[1])
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      delete params.cardtime;
      const req = await getListData(params);
      const result = await req.json();
      if (!result) {
        this.list = [];
        return;
      }
      this.list = result.data.list;
      this.pagerData = {
        pageIndex: result.data.page,
        pageSize: result.data.pageSize,
        total: result.data.allCount,
        totalPage: result.data.pageCount
      };
    },
    clear(){
      this.$refs['tableFilterMain'].clear()
    },
    edit(row) {
      this.$refs.dialog.edit(row)
    },
    async delete(id){
      let confirm = await this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (confirm !== "confirm") return;
      let res = await deteleInfo({id})
      const result = await res.json();
      let { code, msg } = result;
      if (code === 200) {
        this.$message.success("删除成功");
      } else {
        this.$message.error(msg);
      }
      await this.getList();
    },
    addInfo() {
      this.$refs.dialog.add()
    },
    addexecl() {
      this.show = true
    },
    handleSelecte() {},
    exportExecl(){
      this.$refs["tableMain"].downloadExcel("moban", this.list);
    },
    async opationCard(){
      if(this.multipleSelection.length < 1){
        this.$message.error('请选择需要操作的手机号');
        return
      }
      let confirm = await this.$confirm("是否注销所选手机号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (confirm !== "confirm") return;
      let arr = []
      this.multipleSelection.forEach(item=>{
        arr.push(item.phone)
      })
      let query ={
        card_status: 2,
        phones: arr
      }
      let res = await cancleInfo(query)
      const result = await res.json();
      let { code, msg } = result;
      if (code === 200) {
        this.$message.success("修改成功");
      } else {
        this.$message.error(msg);
      }
      await this.getList();
    },
    getdetail(id) {
      this.$router.push({
        name: 'StandingBookDetail',
        params: {id}
      });
    },
  },
};
</script>

<style lang="scss">
.from {
  background: #fff;
  padding: 30px 20px;
  margin-bottom: 20px;
}
.buttoncontent {
  margin-top: 20px;
}
.table{
  background: #fff;
  padding: 20px;
}
.CustomerManageTable__allPage {
  position: relative;
}
</style>
